// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/Layout/Sidemenu/PictureDetails/PictureDetails.css
// module id = 445
// module chunks = 0